import { memo, useCallback, useState } from 'react';

import Button from '../common/button';
import SelectFranchiseModal from '.';
import { ButtonSelectFranchiseProps } from './type';

const SelectFranchiseButton = (props: ButtonSelectFranchiseProps) => {
	const { label = '추가', className, hidden = false, ...rest } = props;

	if (hidden) return null;

	const [open, setOpen] = useState(false);

	const onOpenModal = useCallback(() => {
		setOpen(true);
	}, []);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Button secondary className={className} onClick={onOpenModal}>
				{label}
			</Button>

			<SelectFranchiseModal {...{ ...rest, open, onCancel }} />
		</>
	);
};

export default memo(SelectFranchiseButton);
